import { render, staticRenderFns } from "./use-case-column.vue?vue&type=template&id=f1442fd6"
import script from "./use-case-column.vue?vue&type=script&lang=js"
export * from "./use-case-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports